import api from './api'

export const photoService = {
  // Get all photos
  async getPhotos() {
    const response = await api.get('/photos/')
    return response.data
  },

  // Get featured photos
  async getFeaturedPhotos() {
    const response = await api.get('/photos/featured')
    return response.data
  },

  // Get photos by category
  async getPhotosByCategory(category) {
    const response = await api.get(`/photos/?category=${category}`)
    return response.data
  },

  // Get a specific photo
  async getPhoto(id) {
    const response = await api.get(`/photos/${id}`)
    return response.data
  },

  // Create a new photo (admin)
  async createPhoto(data) {
    const response = await api.post('/photos/', data)
    return response.data
  },

  // Update a photo (admin)
  async updatePhoto(id, data) {
    const response = await api.put(`/photos/${id}`, data)
    return response.data
  },

  // Delete a photo (admin)
  async deletePhoto(id) {
    const response = await api.delete(`/photos/${id}`)
    return response.data
  }
}